import { ReactNode } from 'react'

import {
  KyrgyzstanEmpty,
  KyrgyzstanHeader,
  KyrgyzstanLoader,
} from 'entities/kyrgyzstan'

import { ShareButton } from 'shared/ui/share-button'

import s from './styles.module.scss'

interface KyrgyzstanDetailShellProps {
  header: {
    title?: string
    subtitle?: string
    onGoBack: () => void
  }
  share?: {
    url: string
    text?: string
  }
  state: {
    isLoading: boolean
    error?: string | null
  }
  children: ReactNode
  bottomAction?: ReactNode
}

export const KyrgyzstanDetailShell = ({
  header,
  share,
  state,
  children,
  bottomAction,
}: KyrgyzstanDetailShellProps) => {
  if (state.isLoading) {
    return (
      <div className={s.container}>
        <KyrgyzstanHeader onGoBack={header.onGoBack} />
        <KyrgyzstanLoader />
      </div>
    )
  }

  if (state.error) {
    return (
      <div className={s.container}>
        <KyrgyzstanHeader onGoBack={header.onGoBack} />
        <KyrgyzstanEmpty title={state.error} />
      </div>
    )
  }

  return (
    <div className={s.container}>
      <KyrgyzstanHeader
        title={header.title}
        subtitle={header.subtitle}
        actionRight={
          share ? (
            <ShareButton
              shareUrl={share.url}
              text={share.text}
            />
          ) : undefined
        }
        onGoBack={header.onGoBack}
      />

      <main className={s.content}>{children}</main>

      {bottomAction}
    </div>
  )
}
